var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGalochka = function SvgGalochka(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 110 120"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B4EF8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M8 66.5a93.8 93.8 0 0 1 27.95 28.033L38.5 98.5l5.466-8.904A269.5 269.5 0 0 1 108 18v0"
  })));
};
export default SvgGalochka;